import styled from 'styled-components'

export const StyledCommonLayout = styled.div`
    height: 100%;
    display: grid;
    overflow: hidden;
    grid-template-rows: auto 1fr;
`
